import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * FloatingNavWidget — Floating "Go back" pill rendered bottom-right of the
 * viewport, intentionally offset to the LEFT of the existing global
 * ScrollToTopButton so the two never collide.
 *
 * Designed for long, scroll-heavy public catalogue pages.
 */
const FloatingNavWidget = ({ backTo = '/it-solutions', backLabel = 'Go back' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(backTo);
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label={backLabel}
      title={backLabel}
      data-testid="floating-go-back"
      className="group fixed right-24 bottom-28 z-50 inline-flex items-center gap-2 pl-3 pr-4 h-12 rounded-full bg-[#0F172A] text-white shadow-lg hover:shadow-2xl hover:bg-[#1e293b] hover:scale-[1.03] transition-all"
    >
      <ArrowLeft className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" />
      <span className="text-[12px] font-bold tracking-tight">Back</span>
    </button>
  );
};

export default FloatingNavWidget;
